module.exports = __webpack_public_path__ + "images/DepositPopupGraphica47807df5a359d2cce4a16d340862d65.png";